import { RETAILER_CREATED_ORDERS_KEY } from 'store/news/constants'

const messages = {
  [RETAILER_CREATED_ORDERS_KEY]: (newRetailerOrdersCount) => (
    <span>
      Retailer Updates: You have <var>{newRetailerOrdersCount}</var> new orders
      from your retailers.
    </span>
  ),
}

export default messages
